// extracted by mini-css-extract-plugin
export var filterIncDec = "_d0-0";
export var leftBorder = "_d0-1";
export var rightBorder = "_d0-2";
export var stringInput = "_d0-3";